export const CATEGORIES = [
  {
    name: "Comida",
    image: "https://cdn-icons-png.flaticon.com/512/1046/1046784.png", // 🍔 ejemplo
    subcategories: [
      "Restaurantes",
      "Tacos",
      "Pizza",
      "Parrilla",
      "Mariscos",
      "Comida Corrida",
      "Cafetería",
      "Comida Rápida",
      "Internacional",
      "Postres",
      "Bebidas",
    ],
  },
  {
    name: "Mandados",
    image: "https://cdn-icons-png.flaticon.com/512/3081/3081559.png", // 🛒 ejemplo
    subcategories: [
      "Supermercado",
      "Abarrotes",
      "Frutas y Verduras",
      "Carnicería",
      "Panadería",
      "Lácteos",
      "Mascotas",
    ],
  },
  {
    name: "Otros",
    image: "https://cdn-icons-png.flaticon.com/512/1829/1829586.png", // 📦 ejemplo
    subcategories: ["Papelería", "Electrónica", "Ropa y Accesorios", "Ferretería"],
  },
];